import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import lock from "../../assets/lock-icon.png";
import rateproduct from "../../assets/rateproduct.png";
import "./Home.css";
import Categories from "../Categories/Categories";
import SuccessPartners from "../SuccessPartners/SuccessPartners";
import { MdBrokenImage } from "react-icons/md";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import { fetchHomeData } from "../../services/home.service";
import { fetchFavorites } from "../../services/favorite.service";
import { ToastContainer, toast } from "react-toastify";
import placeholder from "../../assets/placeholder.jpg";

export default function Home() {
  const navigate = useNavigate();

  const [banners, setBanners] = useState([]);
  const [products, setProducts] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(true);
  const [cartItems, setCartItems] = useState([]);
  const [outOfStock, setOutOfStock] = useState([]);
  const [checkedStock, setCheckedStock] = useState(false);

  const getHeaders = () => {
  const token = localStorage.getItem("token");

  const headers = {
    Accept: "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

  const toggleFavorite = async (e, productId, type) => {
    e.stopPropagation();
    const token = localStorage.getItem("token");

    // if (!token) {
    //   toast.info("يجب تسجيل الدخول لإضافة المنتج إلى المفضلة ❤️");
    //   return;
    // }

    const currentList =
      type === "featured" ? featuredProducts : products;

    const targetItem = currentList.find((item) => item.id === productId);
    const wasFavorite = targetItem?.isFavorite;

    const updateList = (list) =>
      list.map((item) =>
        item.id === productId
          ? { ...item, isFavorite: !item.isFavorite }
          : item
      );

    if (type === "featured") {
      setFeaturedProducts((prev) => updateList(prev));
    } else {
      setProducts((prev) => updateList(prev));
    }

    try {
      await axios.get(
        BaseUrl +
          BuyerServicesUrl.AddProductToFavorites.replace("{id}", productId),
        {
          // headers: {
          //   Authorization: `Bearer ${token}`,
          //   Accept: "application/json",
          // },
          headers: getHeaders()
        }
      );

      if (!wasFavorite) {
        toast.success("تمت الإضافة إلى المفضلة ");
      } else {
        toast("تمت الإزالة من المفضلة ", {
          style: {
            background: "#ff7100",
            color: "#fff",
          },
        });
      }
    } catch (err) {
      if (type === "featured") {
        setFeaturedProducts((prev) => updateList(prev));
      } else {
        setProducts((prev) => updateList(prev));
      }

      toast.error("حدث خطأ أثناء تحديث المفضلة ❌");
    }
  };

  const addToCart = async (productId) => {
    if (cartItems.includes(productId)) {
      toast.info("المنتج موجود بالفعل في السلة 🛒");
      return;
    }

    try {
      await axios.post(
        `${BaseUrl}${BuyerServicesUrl.AddToCart}`,
        {
          product_id: productId,
          quantity: 1,
        },
        {
          headers: getHeaders(),
        }
      );

      toast.success("تمت الإضافة إلى السلة 🛒");

      setCartItems((prev) => [...prev, productId]);

      window.dispatchEvent(
        new CustomEvent("cartUpdated", {
          detail: "increment",
        })
      );
    } catch (err) {
      const message =
        err.response?.data?.data ||
        err.response?.data?.message ||
        "";

      if (message.toLowerCase().includes("stock")) {
        setOutOfStock((prev) => [...prev, productId]);
        toast.info("غير متوفر حالياً 🚫");
      } else if (
        message.toLowerCase().includes("unauthenticated") ||
        message.toLowerCase().includes("unauthorized") ||
        err.response?.status === 401
      ) {
        toast.info("يرجى تسجيل الدخول أولاً 🛒");
      } else {
        toast.error("حدث خطأ أثناء الإضافة ❌");
      }
    }
  };

  useEffect(() => {
    if (!products.length && !featuredProducts.length) return;

    const checkStockFromData = (list) =>
      list
        .filter(
          (item) =>
            item.quantity === 0 ||
            item.quantity === "0" ||
            item.status === "out_of_stock" ||
            item.status === "out of stock" ||
            item.status === "unavailable"
        )
        .map((item) => item.id);

    const allOut = [
      ...checkStockFromData(products),
      ...checkStockFromData(featuredProducts),
    ];

    setOutOfStock([...new Set(allOut)]);
    setCheckedStock(true);
  }, [products, featuredProducts]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchHome = async () => {
      try {
        const token = localStorage.getItem("token") || null;

        const homeData = await fetchHomeData(token);

        let favoriteIds = [];

        if (token) {
          const favorites = await fetchFavorites(token);
          favoriteIds = favorites.map((fav) => fav.id);
        }

        const mergeFavorites = (list) =>
          list.map((item) => ({
            ...item,
            isFavorite: favoriteIds.includes(item.id),
          }));

        setBanners(homeData.bannars || []);
        setFeaturedProducts(mergeFavorites(homeData.ProductToqTajah || []));
        setProducts(mergeFavorites(homeData.products || []));
      } catch (error) {
        console.error("Home error:", error);
      }
    };

    fetchHome();

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    if (!banners.length) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [banners]);

  const imgWrapStyle = {
    width: "100%",
    height: "220px",
    borderRadius: "16px",
    overflow: "hidden",
    background: "#f3f3f3",
    position: "relative",
  };

  const imgStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  if (loading) {
    return (
      <div className="home-loader mt-5 mb-5" style={{ minHeight: "100vh" }}>
        <div className="home-spinner mb-5"></div>
        <p>جاري تحميل الصفحة...</p>
      </div>
    );
  }

return (
  <div className="hero-wrapper pt-5 mt-4">
    <ToastContainer
      position="bottom-right"
      autoClose={2000}
      rtl
      theme="colored"
    />

    <div className="hero-container">
      {/* <div className="hero-left">
        {banners.map((img, index) => (
          <img
            key={index}
            src={img}
            alt="banner"
            className={`slide-image ${index === current ? "fade-in" : ""}`}
          />
        ))}
      </div> */}
      {/* <div
  className="hero-left"
  style={{
    backgroundImage: `url(${bannerImageFromApi})`
  }}
></div> */}
{/* <div
  className="hero-left"
style={{
  "--bg": `url(${banners[current]})`,
  backgroundImage: `url(${banners[current]})`,
}}
></div> */}
<div className="hero-left">
  <img
    src={banners[current]}
    alt=""
    className="hero-banner-img"
  />
</div>

{/* 
      <div className="hero-right">
        <span className="hero-tag">
          <img className="lock" src={lock} alt="secure" />
          <p className="web-text mb-0">
            أفضل موقع للتسوق الإلكتروني
          </p>
        </span>

        <h1 className="hero-heading">
          أفضل العروض بين يديك
        </h1>

        <p className="web-order">
          نوفر لك منتجات متنوعة من أفضل التجار بأفضل الأسعار
        </p>

        <div className="products-info">
          <button
            className="customerbtn"
            onClick={() => navigate("/productlist")}
          >
            تسوق الآن
          </button>

          <Link
            className="products-link-anchor"
            onClick={() => navigate("/productlist")}
          >
            عرض الكل
          </Link>
        </div>

        <div className="home-rating">
          <div className="icons-stack">
            <i className="plusicon">+</i>

            <img
              src={rateproduct}
              alt=""
              className="img-1"
            />

            <img
              src={rateproduct}
              alt=""
              className="img-2"
            />

            <img
              src={rateproduct}
              alt=""
              className="img-3"
            />
          </div>

          <div className="rate-box-text">
            <span className="ratemaintext">
              + 4.9 تقييم
            </span>

            <p className="rate-sub mb-0">
              ثقة أكثر من 2000 عميل
            </p>
          </div>
        </div>
      </div> */}
    </div>

    <Categories />

    <div className="container">
      <div className="homeheader d-flex justify-content-between mb-3">
        <h3 className="fw-bold">
          عروض طوق نجاة
        </h3>

        <span
          className="home-view-btn"
          onClick={() =>
            navigate("/productlist?section=featured")
          }
          style={{ cursor: "pointer" }}
        >
          رؤية المزيد
        </span>
      </div>

      <div className="row">
        {featuredProducts.map((item) => {
          console.log("IMAGES:", item.images);
          console.log("BASE URL:", BaseUrl);
          console.log("ITEM:", item);

          return (
            <div
              className="col-md-3 col-sm-6 mb-4"
              key={item.id}
            >
              <div className="product-card">
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    navigate(
                      `/advertisementdetails/${item.id}`
                    )
                  }
                >
                  <div style={imgWrapStyle}>
                    <div
                      className={`fav-btn ${
                        item.isFavorite ? "active" : ""
                      }`}
                      onClick={(e) =>
                        toggleFavorite(
                          e,
                          item.id,
                          "featured"
                        )
                      }
                    >
                      {item.isFavorite ? "❤" : "♡"}
                    </div>

                    <img
                      // src={
                      //   item.image?.[0]
                      //     ? `${BaseUrl}${item.image[0]}`
                      //     : placeholder
                      // }
                      src={
  item.image?.[0]?.url
    ? item.image[0].url
    : placeholder
}
                      alt={item.name}
                      style={imgStyle}
                      onError={(e) => {
                        e.target.src = placeholder;
                      }}
                    />
                  </div>

                  <h6 className="mt-3">
                    {item.name}
                  </h6>

                  <p className="product-desc">
                    {item.description
                      ?.split(" ")
                      .slice(0, 3)
                      .join(" ")}
                    ....
                  </p>

                  <p className="price">
                    {item.priceAfterDiscount > 0
                      ? item.priceAfterDiscount
                      : item.price}{" "}
                    {item.currency_type}
                  </p>
                </div>

                <button
                  className={`addcart text-white border-0 pt-2 pb-2 mb-3 ${
                    outOfStock.includes(item.id)
                      ? "cart-disabled"
                      : ""
                  }`}
                  disabled={outOfStock.includes(item.id)}
                  onClick={(e) => {
                    e.stopPropagation();
                    addToCart(item.id);
                  }}
                >
                  {!checkedStock
                    ? "..."
                    : item.quantity === 0 ||
                      outOfStock.includes(item.id)
                    ? "غير متوفر حالياً"
                    : "أضف الى السلة"}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>

    <div className="container mt-5">
      <div className="d-flex justify-content-between">
        <h3 className="mb-1 fw-bold">
          الإقتراحات
        </h3>

        <span
          className="home-view-btn"
          onClick={() =>
            navigate("/productlist?section=suggestion")
          }
          style={{ cursor: "pointer" }}
        >
          رؤية المزيد
        </span>
      </div>

      <div className="row">
        {products.map((item) => (
          <div
            className="col-md-3 col-sm-6 mb-4"
            key={item.id}
          >
            <div className="product-card">
              <div
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate(
                    `/advertisementdetails/${item.id}`
                  )
                }
              >
                <div style={imgWrapStyle}>
                  <div
                    className={`fav-btn ${
                      item.isFavorite ? "active" : ""
                    }`}
                    onClick={(e) =>
                      toggleFavorite(
                        e,
                        item.id,
                        "products"
                      )
                    }
                  >
                    {item.isFavorite ? "❤" : "♡"}
                  </div>

                  <img
                    // src={
                    //   item.image?.[0]
                    //     ? `${BaseUrl}${item.image[0]}`
                    //     : placeholder
                    // }
                    src={
  item.image?.[0]?.url
    ? item.image[0].url
    : placeholder
}
                    alt={item.name}
                    style={imgStyle}
                    onError={(e) => {
                      e.target.src = placeholder;
                    }}
                  />
                </div>

                <h6 className="mt-3 fw-bold pt-1">
                  {item.name}
                </h6>

                <p className="product-desc pb-1">
                  {item.description
                    ?.split(" ")
                    .slice(0, 3)
                    .join(" ")}
                  ....
                </p>

                <p className="price pb-2">
                  {item.priceAfterDiscount > 0
                    ? item.priceAfterDiscount
                    : item.price}{" "}
                  {item.currency_type}
                </p>
              </div>

              <button
                className={`addcart text-white border-0 pt-2 pb-2 mb-3 ${
                  outOfStock.includes(item.id)
                    ? "cart-disabled"
                    : ""
                }`}
                disabled={outOfStock.includes(item.id)}
                onClick={(e) => {
                  e.stopPropagation();
                  addToCart(item.id);
                }}
              >
                {!checkedStock
                  ? "..."
                  : item.quantity === 0 ||
                    outOfStock.includes(item.id)
                  ? "غير متوفر حالياً"
                  : "أضف الى السلة"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>

    <SuccessPartners />
  </div>
);
}
